var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgWarningFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15908 0.51488C7.52793 -0.171625 8.47206 -0.171627 8.84092 0.514877L15.8747 13.6058C16.2365 14.2791 15.7717 15.1111 15.0338 15.1111H0.966234C0.228306 15.1111 -0.236465 14.2791 0.125313 13.6058L7.15908 0.51488Z",
    fill: "var(--yellow-6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27815 4.44444H8.86503L8.75765 10.6368H7.38554L7.27815 4.44444ZM7.11111 12.3669C7.11111 12.0964 7.20259 11.8697 7.38554 11.6868C7.56848 11.5039 7.79518 11.4124 8.06563 11.4124C8.34402 11.4124 8.5747 11.5039 8.75765 11.6868C8.94059 11.8697 9.03207 12.0964 9.03207 12.3669C9.03207 12.6453 8.94059 12.876 8.75765 13.0589C8.5747 13.2419 8.34402 13.3333 8.06563 13.3333C7.79518 13.3333 7.56848 13.2419 7.38554 13.0589C7.20259 12.868 7.11111 12.6373 7.11111 12.3669Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningFilled);
export default __webpack_public_path__ + "static/media/warningFilled.699f9128948d00b3c0fae6dc2731d991.svg";
export { ForwardRef as ReactComponent };